const baseApi = process.env.REACT_APP_API;

export const network = {
    baseApi
};